import { findFlightEvaluationsByCriteria } from '@src/main/modules/reports/flight/application/use-cases/find-flight-evaluations-by-criteria.usecase';
import { createFlightEvaluationHttpRepository } from '@src/main/modules/reports/flight/infrastructure/repository/FlightEvaluationHttpRepository';
import {
  BriefFlightEvaluation,
  EvaluationCriteria,
} from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDetailedFlightEvaluations = (criteria: EvaluationCriteria) => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(
    () => (user?.token ? createFlightEvaluationHttpRepository(tokenProvider) : null),
    [tokenProvider, user?.token],
  );

  return useQuery<BriefFlightEvaluation[], Error>({
    queryKey: ['flightDetailedEvaluations', JSON.stringify(criteria)],
    queryFn: async () => {
      if (!repository) return [];
      const response = await findFlightEvaluationsByCriteria(repository, criteria);
      return response.items;
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });
};
